import {HttpModelConverter} from "../../../../converter/httpModel.converter";
import {AbstractDataServiceAdapter} from "./abstractDataService.adapter";
import {QueryParams} from "@ngrx/data";
import {Observable} from "rxjs";
import {Page} from "../../../../../../shared/model/core/page.model";
import {SummaryModel} from "../../../../../common/entity/summary.model";
import {WithSummaryModel} from "../../../../../common/entity/dto/plain/withSummary.model";
import {AbstractDataServiceV2} from "../abstractDataServiceV2";
import {Injectable} from "@angular/core";

@Injectable()
export abstract class AbstractDataServiceDtoSummaryAdapter<S extends SummaryModel, SC extends HttpModelConverter<S>, T extends WithSummaryModel<S>> extends AbstractDataServiceAdapter<T, S, SC> {


    protected constructor(dataService: AbstractDataServiceV2<T, any>, converter: SC) {
        super(dataService, converter);
    }

    getSummaries(path: string, params?: string | QueryParams): Observable<Page<S>> {
        return super.getMultipleWithQuery(path + '/summaries', params);
    }

    getOneSummary(path: string, params?: string | QueryParams): Observable<S> {
        return super.getOneWithQuery(path + '/summaries', params);
    }

    buildEntityFromStoreEntity(storedEntity: T): S {
        return storedEntity.summary;
    }

    buildStoredEntityEntity(entity: S): T {
        const storedEntity = this.newStoredEntityInstance();
        storedEntity.summary = entity;
        return storedEntity;
    }

    isDtoSummary(): boolean {
        return true;
    }

}